import React from 'react';
import { Link } from 'react-router-dom';

const values = [
  { icon: 'fas fa-handshake', title: 'Integrity', desc: 'We believe in transparent pricing, honest timelines and clear communication at every step.' },
  { icon: 'fas fa-award', title: 'Quality First', desc: 'We never compromise on materials or craftsmanship. Every product leaves our facility with rigorous QC checks.' },
  { icon: 'fas fa-lightbulb', title: 'Innovation', desc: 'We continually invest in new techniques and technologies to deliver cutting-edge signage solutions.' },
 // { icon: 'fas fa-users', title: 'Client Focus', desc: 'Your success is our success. We work as a long-term partner, not just a vendor.' },
];

function About() {
  return (
    <>
      <div className="page-hero">
        <div className="container">
          <div className="breadcrumb">
            <Link to="/">Home</Link>
            <i className="fas fa-chevron-right" />
            <span>About Us</span>
          </div>
          <h1 className="page-hero-title">
            About <span>Expert Advertising</span>
          </h1>
          <p className="section-desc light" style={{ marginTop: 16 }}>
            India's most trusted signage and advertising partner since 2002.
          </p>
        </div>
      </div>

      {/* Story */}
      <section className="about-story">
        <div className="container">
          <div className="about-story-grid">
            <div className="story-image-stack">
              <img
                src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&q=80"
                alt="Our Workshop"
                className="story-img-main"
                loading="lazy"
              />
              <img
                src="https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=600&q=80"
                alt="Our Team"
                className="story-img-accent"
                loading="lazy"
              />
            </div>
            <div>
              <span className="section-label">Our Story</span>
              <h2 className="section-title">Built on Craft,<br />Driven by Passion</h2>
              <p className="section-desc" style={{ marginTop: 20 }}>
                Expert Advertising India was founded in 2002 with a single vision: to deliver
                signage that doesn't just inform — it inspires. What began as a small workshop
                in New Delhi has grown into one of India's most respected full-service signage companies.
              </p>
              <p className="section-desc" style={{ marginTop: 16 }}>
                Over two decades, we have completed more than 2,500 projects for clients ranging from
                neighbourhood retailers to Fortune 500 companies, government bodies and premier hospitals.
                Our in-house team of designers, fabricators and installation experts ensures every sign
                meets our uncompromising standards.
              </p>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24, marginTop: 36 }}>
                {[
                  { num: '2002', label: 'Founded' },
                  { num: '2500+', label: 'Projects' },
                  { num: '150+', label: 'Happy Clients' },
                  { num: '15+', label: 'Cities' },
                ].map((s, i) => (
                  <div key={i} style={{ borderLeft: '3px solid var(--primary)', paddingLeft: 20 }}>
                    <div style={{ fontFamily: 'var(--font-display)', fontSize: '2.4rem', color: 'var(--secondary)', lineHeight: 1 }}>{s.num}</div>
                    <div style={{ fontFamily: 'var(--font-condensed)', fontSize: '11px', letterSpacing: '0.15em', textTransform: 'uppercase', color: 'var(--text-light)', marginTop: 4 }}>{s.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section style={{ padding: '80px 0', background: 'var(--off-white)' }}>
        <div className="container">
          <div className="text-center">
            <span className="section-label">What We Stand For</span>
            <h2 className="section-title">Our Core Values</h2>
          </div>
          <div className="services-grid" style={{ marginTop: 56 }}>
            {values.map((v, i) => (
              <div className="service-card" key={i}>
                <div className="service-icon"><i className={v.icon} /></div>
                <div className="service-title">{v.title}</div>
                <p className="service-desc">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process */}
      <section style={{ padding: '80px 0', background: 'var(--secondary)' }}>
        <div className="container">
          <div className="text-center">
            <span className="section-label">How We Work</span>
            <h2 className="section-title light">Our Process</h2>
          </div>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: 24,
            marginTop: 56,
          }}
          className="process-steps"
          >
            {[
              { step: '01', title: 'Consultation', desc: 'We understand your brand, goals and requirements through a detailed briefing.' },
              { step: '02', title: 'Design', desc: 'Our designers create visual mockups and 3D renders for your approval.' },
              { step: '03', title: 'Fabrication', desc: 'In-house manufacturing with quality materials and precision craftsmanship.' },
              { step: '04', title: 'Installation', desc: 'Professional installation by our certified team with safety compliance.' },
            ].map((p, i) => (
              <div
                key={i}
                style={{
                  borderTop: '2px solid rgba(212,160,23,0.3)',
                  paddingTop: 28,
                  position: 'relative',
                }}
              >
                <div style={{
                  fontFamily: 'var(--font-display)',
                  fontSize: '3.5rem',
                  color: 'rgba(212,160,23,0.15)',
                  lineHeight: 1,
                  position: 'absolute',
                  top: 16,
                  right: 0,
                }}>{p.step}</div>
                <div style={{
                  fontFamily: 'var(--font-condensed)',
                  fontSize: '11px',
                  fontWeight: 700,
                  letterSpacing: '0.2em',
                  textTransform: 'uppercase',
                  color: 'var(--primary)',
                  marginBottom: 10,
                }}>Step {p.step}</div>
                <div style={{
                  fontFamily: 'var(--font-condensed)',
                  fontSize: '1.2rem',
                  fontWeight: 700,
                  color: 'var(--white)',
                  textTransform: 'uppercase',
                  letterSpacing: '0.06em',
                  marginBottom: 12,
                }}>{p.title}</div>
                <p style={{ fontSize: '0.88rem', color: 'rgba(255,255,255,0.55)', lineHeight: 1.7 }}>{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <div className="cta-inner">
            <div>
              <h2 className="cta-title">Let's Work <span>Together</span></h2>
              <p className="cta-desc">Partner with Expert Advertising India for your next signage project.</p>
            </div>
            <div className="cta-buttons">
              <Link to="/contact" className="btn btn-primary">
                Contact Us <i className="fas fa-arrow-right" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      <style>{`
        @media (max-width: 768px) {
          .process-steps { grid-template-columns: 1fr 1fr !important; }
        }
        @media (max-width: 480px) {
          .process-steps { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </>
  );
}

export default About;
